var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemoAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438.07 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0253a2;}.cls-2{fill:#0063cb;}.cls-3{fill:#e9f6ff;}.cls-4{fill:#e7f5fe;}.cls-5{fill:#e9d6b8;}.cls-6{fill:#fff;}.cls-7{fill:#fec00f;}.cls-8{fill:#7eb3ff;}.cls-9{fill:#d1dbea;}.cls-10{fill:#e2c59c;}.cls-11{fill:#c5e1f9;}.cls-12{fill:#12344a;}.cls-13{fill:#161711;}.cls-14{fill:#163f59;}.cls-15{fill:#194866;}.cls-16{fill:#9ac7f7;}.cls-17{fill:#387bff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "219.04 165.03 438.07 245.44 438.07 368.62 0 368.62 0 245.44 219.04 165.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "219.04 450 438.07 369.59 438.07 246.41 219.04 326.81 219.04 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "219.04 450 0 369.59 0 246.41 219.04 326.81 219.04 450"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m131.4,242.28l-.51,5.89-1.08,4.89-1.98,1.32-1.49.45-.43.83-5.15,3.4c-1.39.61-3.35.92-5.72.35-.81-.19.32-2.4.6-2.73,1.62-1.92,4.1-4,4.1-4l4.01-4.94,4.54-6.19,3.1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m177.27,235.88l-1.29,2.36-.7,2.66.09,4.24,2.29.34,1.73-.36,1.13.8s6.49,1.29,8.92,1.38c4.04.14,6.25-.27,7.05-1.05.44-.43-1.44-1.3-2.06-1.39-3.59-.56-7.36-2.87-7.36-2.87l-2.95-3.35-.57-2.37-6.3-.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "159.18 107.54 122.01 247.49 131.45 248.09 149.49 203.57 153.86 190.14 175.31 137.46 179.44 108.49 159.18 107.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "175.49 236.3 178.16 182.5 175.81 157.84 172.96 124.01 177.27 101.35 192.04 103.72 193.71 140.21 192.79 174.81 192.06 187.85 186.49 239.21 175.49 236.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m211.08,60.06s8.64,1.48,22.98-6.62c4.84-2.73,1.58.98-.87,5.77-2.44,4.8-14.54,9.38-25.79,8.32-11.25-1.06,3.67-7.48,3.67-7.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m232.1,56.26s.43-5.96,1.76-6.99c1.32-1.03,6.39-4.47,6.39-4.47l1.37-.76s1.55,1.09-1.88,3.36c-3.43,2.28-1.23,2.1-1.23,2.1l3.79-.85,4.7-.67,2.06-.57s1.15-.41,1.5-.27c.99.42.29,1.08.29,1.08l-7.88,2.94,7.87-.66s1.01.09,1.14.64c.12.52-.21.56-.21.56l-8.84,2.95,4.08.14s.99.12,1.13.64c.16.57.22.72.22.72l-15.88,1.75-.38-1.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 227.18,
    y: 55.09,
    width: 5.92,
    height: 7.35,
    transform: "translate(4.9 134.18) rotate(-32.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m243.5,52.59l5.55-.12s1.24-.17,1.85.13c.7.34.41,1.01.41,1.01l-8.39,1.05.58-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m174.66,35.07s-2.46,3.88,6.45,26.63c4.98,12.71,7.8,20.77,13.8,21.33,10.28.97,37.59-16.42,37.59-16.42l-4.44-12.58s-20.27,9.92-26.25,7.15c-1.4-.65-10.47-25.34-15.25-28.53-2.22-1.48-10.44,1.64-11.91,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m197.86,136.99l-5.48,5.68-4.45-14.92-4.37,17.23-34.93-4.71s5.17-30.41,8.48-44.5l-11.21-35.38s.46-25.33,10.03-26.7c15.46-2.21,29.54-1.6,29.54-1.6,0,0,21.88,59.24,12.39,104.9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.3 33.47 177.87 66.68 160.62 40.23 160.32 33.37 175.3 33.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "153.28 123.68 147.98 121.1 147.33 120.5 147.99 119.32 149.13 119.39 148.74 116.06 154.07 114.8 156.76 113.36 154.71 122.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m136.79,91.35l19.85,21.6s-.49,3.34-2.08,1.67c-.19-.2.67-.91-.49-1.47-4.71-2.24-15.65-5.49-19.84-9.11-5.5-4.76-9.54-10.49-9.54-10.49l12.11-2.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 144.13,
    y: 103.64,
    width: 6.67,
    height: 7.35,
    transform: "translate(-32.1 139.23) rotate(-46.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m171.83,38.83s10.97,24.98,4.19,50.5c-.53,2.01-3.13,3.2-3.13,3.2l-3.01-3.3s3.56-29.34,1.95-50.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "170.63 37.78 169.96 42.08 160.36 35.49 160.29 33.37 170.63 37.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "172.27 33.15 174.47 41.53 172.29 38.66 172.27 33.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m147.27,59.56l-8.59,29.98,12.2,15.77s-4.81,7.15-6.81,6.31c-13.82-5.78-24.76-25.62-24.76-25.62l15.2-42.26s3.28-6.76,15.87-8.86c9.12-1.51-2.52,22.19-3.12,24.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m158.84,27.96c.43,1.6,1.16,4.06,1.89,5.49,1.14,2.22,10.12,4.66,11.49,4.91,1.38.25-.72-6.82-.81-8.44-.07-1.24-.84-.81.02-2.65l-12.59.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "172.03 32.55 174.69 39.97 178.1 68.42 183.01 46.06 178.97 42.19 181.16 38.59 176.34 32.72 172.03 32.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m187.81,110.84l.41,15.68-3.08-14.15-28.95,18.63s-2.4-21.14.92-35.24l-11.21-35.38s-12.12-19.96,1.17-24.76c2.07-.75,9.3-1.7,11.53-1.85,3.15-.22,9.03,8.82,10.45,11.42,1.52,2.78,11.36,28.01,11.36,28.01l7.4,37.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "159.66 33.16 154.49 34.31 158.65 42.06 164.57 45.58 164.53 52.29 179.93 74.25 169.87 45.29 159.66 33.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "159.66 32.75 154.49 33.9 158.63 41.68 164.54 45.03 164.48 51.44 179.82 72.42 169.84 44.74 159.66 32.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "172.21 38.36 170.63 38.19 170.79 42.09 172.7 43.45 173.79 41.81 172.21 38.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m173.69,24.61c.3,1.39-.57,2.75-1.95,3.05l-11.27,2.45c-1.38.3-2.74-.58-3.05-1.96l-3.63-16.68c-.3-1.38.57-2.75,1.96-3.05l11.26-2.44c1.38-.3,2.74.57,3.05,1.96l3.63,16.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m170.83,11.36s1.16-1.94,1.22-3c.03-.53-.87-2.32-2.28-2.78-1.41-.45-2.16,1.13-2.16,1.13,0,0,2.24.68,2.43,1.07.2.4.78,3.58.78,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m154.28,19.22s-3.09-6.04-3.19-7.98c-.09-1.95-.17-3.3,2.08-4,3.37-1.06,3.57-.34,5.01-1.75,1.44-1.4,3.9-4.57,4.87-5.04,1.63-.79,4.45-.8,5.26,2.41.6,2.37,2.23,2.63,2.21,2.73-.07.32-.64.73-1.61,1.51-2.79,2.25-4.6,2.97-7.13,2.86-2.54-.1-7.3-.49-7.43,1.4-.14,1.89,1.25,7.26,1.14,7.73-.12.47-.7.37-1.19.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m158.92,23.46c.1.46-.2.92-.66,1.02l-2.43.53c-.46.1-.92-.19-1.02-.65l-.97-4.45c-.1-.46.19-.92.65-1.02l2.43-.53c.46-.1.92.19,1.01.65l.97,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m173.43,20.3c.1.46-.19.92-.65,1.02l-2.43.53c-.46.1-.92-.19-1.02-.66l-.97-4.45c-.1-.46.19-.92.65-1.01l2.43-.53c.46-.1.91.2,1.01.66l.97,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m155.68,20.45s1.43,6.57,1.9,8.76c.43,1.98,2.17,6.16,13.35,3.72,6.62-1.43,5.32-6.25,4.97-7.85-.26-1.22-2.44-4.56-3.29-5.11-.03-.02.59,2.71.59,2.71,0,0-1.95-2.34-5.1-1.66-5.08,1.1-5.59,4.33-7.83,4.76-1.73.33-3.64-2.19-4.6-5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m166.96,25.79l3.47-.76c.46-.1.75-.55.65-1.02l-.11-.49-5.14,1.12.11.49c.1.46.56.75,1.02.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 151.12,
    y: 58.2,
    width: 12.19,
    height: 3.7,
    transform: "translate(-7.06 23.5) rotate(-8.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m279.47,165.23c1.09-.67,4.82,3.48,6.41,7.16,3.11,7.21,3.91,11.19,5.11,19.14,1.91,12.61,5.14,32.63,6.21,41.15.96,7.68,4.05,16.76-.57,15.48.07-10.54-4.78-26.44-7.59-34.79-9.6-28.51-12.93-46.09-9.57-48.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m301.41,172c-.41-2.02-.83-4.01-1.25-5.97-1.43-2.85-2.68-4.36-3.63-4.13-3.6.85-6.86,17.14,4.45,55.83.57,1.95,8.16,35.68,8.11,34.85-1.31-21.66-1.63-50.59-7.69-80.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m309.47,255.08c1.95,3.95,4.39,6.74,5.43,6.22,1.04-.51.31-4.14-1.65-8.09-1.95-3.95-4.39-6.74-5.43-6.22-1.05.52-.31,4.14,1.65,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m308.87,252.73c1,3.1,3.13,5.33,4.17,4.82,1.04-.52.66-3.17-.91-6.02-1.99-3.6-2.74-4.64-2.91-7.22-.16-2.42-4.12-3.21-.35,8.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m288.63,246.72s1.05-.45,3.94-1c1.69-.32,2.97-.31,3.58-.94,1-1.05.45-3.58.94-3.47,2.39.55,3.22,6.14,1.82,6.84-1.39.7-9.28-.23-9.93-.28-.65-.05-.55-1.29-.35-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m290.27,246.22c-.45,1.88,5.33,1.12,6.82.63,1.43-.46,2.34-.61,2.34-.61.06,0,.12-.01.18-.01,0,.04.02.09.02.14,0,1.03.45,2.41-1.2,2.41h-10.36c-8.47,0,2.2-2.6,2.19-2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m274.64,23.26l2.22-15.35c2.82-2.97,6.43-4.55,10.1-4.02,7.08,1.03,11.71,9.51,10.35,18.96-1.37,9.45-8.22,16.27-15.3,15.25-4.96-.72-8.71-5.09-10.05-10.89,1.42-.87,2.44-2.27,2.68-3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m302.76,32.12c.27,2.45-2.32,4.75-5.78,5.13l-7.89.87c-3.46.38-6.48-1.3-6.75-3.76l-2.47-22.38c-.27-2.45,2.31-4.75,5.77-5.13l7.89-.87c3.46-.38,6.48,1.3,6.75,3.75l2.47,22.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m282.19,41.73c-4.68,2.02-7.02,1.39-3.45,2.9,1.72,2.1,23.68-.83,24.88-3.55.2-.46-8.72-1.77-8.77-2.11-.55-3.95-.76-7.29.34-11.71-.05-.35-.31-.62-.59-.61-1.67.05-3.34.06-5.01.11-.28.01-3.55.74-2.82,2.3.36,4.31.36,10.53-4.59,12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m280.7,28.77c-.07-.15-.15-.31-.22-.47-.02-.05-.04-.09-.07-.15-.09-.2-.17-.4-.25-.61-.02-.06-.04-.11-.06-.17-.06-.16-.12-.32-.17-.48-.03-.09-.06-.18-.09-.27-.04-.14-.09-.27-.13-.42-.03-.09-.06-.19-.09-.29-.05-.18-.1-.37-.15-.55-.03-.14-.07-.28-.1-.42-.03-.13-.06-.26-.09-.39-.03-.13-.05-.26-.08-.4-.02-.11-.05-.22-.07-.34-.02-.09-.04-.18-.06-.28,0,0,0,0,0,0-.27-1.59.27-9.09,1.53-12.67.15-.43.62-.77,1.26-.71,3.86.43,15.62-.11,12.58,10.6h0s-.18.96-.27,1.38c0,.04-.02.07-.03.11-.09.43-.2.85-.31,1.25,0,.03-.01.05-.02.08-.11.41-.24.82-.37,1.22,0,.01,0,.03-.01.04-1.68,5.05-4.63,8.39-7.75,8.17-1.82-.13-3.42-1.44-4.62-3.56h0s-.02-.03-.02-.05c-.09-.16-.18-.33-.27-.49-.03-.05-.05-.1-.08-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m345.01,37.74s.82.39,1.16-.23c.56-1.03.77-3.37.8-4.21.04-.93-.5-5.36-.5-5.36,0,0-.91,1.39-.69,3.17.31,2.6-.77,6.62-.77,6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m345.1,37.13c.74-1.51.36-3.42-.64-5.55-.95-2.03-.26-3.3-.26-3.3,0,0,.75,1.24,1.89,4.54.32.93.61,1.95.57,2.92-.11,2.93-3.47,5.26-1.56,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m313.63,55.66c4.27,3.16,8.05,14.25,10.99,21.28,1.66,3.96,1.05,6.95,1.05,6.95,0,0-1.45,9.29-12.51-16.03-2.77-6.33-1.12-13.39.48-12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m345.07,35.29l.71.46.48,2.86s-1.29,5.07-2.47,6.81c-1.18,1.74-5.92,15.42-6.7,16.03-1.39,1.08-4.14-2.64-4.14-2.64,0,0,6.03-9.57,7.25-12.64,1.22-3.07,1.45-8.05,1.89-9.27.75-2.09,1-3.19,1-3.19,0,0,1.06.55.08,3.89-.25.88.87.7.87.7l1.02-3.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "305.62 71.67 276.31 71.42 272.72 37.9 307.51 41.2 305.62 71.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m274.63,171.55c14.42,2.26,17.02.34,33.59-2.02,1.57.03,8.28-16.1,3.55-58.63-.97-8.76-7.6-15.8-6.08-39.59-9.85-.19-19.7-.38-29.56-.57,3.92,21.63-19.5,24.98-1.5,100.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m273.65,80.44l4.16-29.39-1.01-11.85c-.69-.69-1.56-1.15-2.54-1.27l-.66-.08c-2.57-.31-4.87,1.85-5.15,4.83l-3.27,40.25,8.48-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m320.53,84.04l-13.3-25.65-4.05-14.99c.52-.74,1.27-1.35,2.19-1.69l.62-.24c2.42-.91,5.11.32,6.01,2.73l14.17,29.3-5.65,10.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m345.28,38.92s.81-2.55.4-3.83c-.29-.89-2.32-4.86-2.32-4.86,0,0-.37,1.62.44,3.21,1.19,2.33,1.47,5.48,1.47,5.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m344.05,38.3s-.74.17-.99-.06c0,.25.05.51.07.7.05.44-.2,3.44-.2,3.44,0,0,.6-2.13.9-2.71.19-.37.4-1.26.58-2.01.02-.09-.01-.26,0-.43l-.36,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m343.18,37.61c.66-2.24.39-3.23.15-3.63-.15.53-.41,1.38-.83,2.56-.15.42-.28,1.3-.43,2.4-.03.21.76.41,1.07,2.21.06.33.66-1.64.76-2.83-.3.01-.91-.03-.71-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m287.96,25.72c1.41-.87,2.43-2.27,2.68-3.96l2.22-15.35c.13-.14.28-.26.42-.4l.27-.03c3.46-.38,6.48,1.3,6.75,3.75l2.47,22.38c.21,1.89-1.29,3.68-3.58,4.58-.39,0-.79-.03-1.18-.09-4.95-.72-8.71-5.09-10.05-10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m274.26,37.92l8.99.18s4.9,28.24,4.9,36.53-5.65,30.88-5.27,41.42c.38,10.54.13,50.53.13,50.53h-16.01s-2.58-53.17,3.45-73.51c4.81-16.23,3.81-55.16,3.81-55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m283.25,38.1l-4.52-.38v6.9s2.64,3.27,2.64,3.27l-1.13,3.39,3.77,15.06v29.75s4.89-26.36,3.39-31.63c-1.51-5.27-4.14-26.36-4.14-26.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m298.31,39.99l9.2,1.21s-1.29,27.03-1.67,34.94c-.38,7.91,4.14,22.22,6.78,31.63,4.63,16.51,4.82,56.88,4.82,56.88,0,0-9.7,1.94-21.34,1.94,0,0-2.68-25.3-2.31-63.71.38-38.41,4.52-62.89,4.52-62.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "296.05 38.85 292.28 64.46 294.17 105.13 297.18 61.83 300.94 52.41 299.81 49.02 301.7 47.14 300.19 38.85 296.05 38.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "297.41 49.83 266.75 46.76 277.22 86.68 305.46 89.69 297.41 49.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m280.34,67.18c3.46-5.35,2.5-9.21,3.11-11.81.61-2.6.83-5.48.85-5.45,1.31,2.52.26,4.29.37,5.59.12,1.29-.08.85,1.29-.97.78-1.04.26-4.05.19-6.04-.07-1.72.34-2.51.34-2.51,0,0,.87,2.5,1.14,5.17.33,3.22.06,6.77-.13,7.54-.33,1.4-2.53,5.05-4.49,7.4-2.21,2.65-5.18,4.91-2.68,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m268.56,80.66c7.53-9.04,17.52-19.34,17.52-19.34l-13.71,23.49s-7.58.37-3.81-4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m267.07,78.2s-4.86,6.53-.48,8.95c2.48,1.37,4.48.51,5.91-1.49,2.65-3.71,5.46-8.07,5.46-8.07l-4.73-6.19-6.16,6.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m287.62,56.49s1.42-4.78,1.33-5.82c-.06-.71-.91-4.04-.91-4.04,0,0-.66,1.72-.4,3.07.27,1.36-.02,6.79-.02,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m333.71,56.18s6.03,2.64,5.27,5.27c-.75,2.64-7.91,23.35-12.43,25.23-4.52,1.88-6.78-4.14-7.16-5.65-.38-1.51,14.31-24.85,14.31-24.85Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoAdmin);
export default __webpack_public_path__ + "static/media/Demo_Admin.b4822d632b222afa345a71429f0cf118.svg";
export { ForwardRef as ReactComponent };